import { useMutation, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { announcementApi } from 'src/Services/API';

const useDismissAssetAnnouncement = () => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<void, unknown, string>(id => announcementApi.dismissForAsset(assetId!, id), {
    onSuccess: () => {
      queryClient.setQueryData(['active-asset-announcement', assetId], null);
      queryClient.invalidateQueries({ queryKey: ['active-asset-announcement', assetId] });
    },
  });
};

export default useDismissAssetAnnouncement;
